/* istanbul ignore next */
const ACTIONS = {
    VERIFY_PM_ELIGIBILITY: 'VERIFY_PM_ELIGIBILITY',
    UPDATE_ONBOARDING_STATUS_TO_BMX_IDENTIFIED: 'UPDATE_ONBOARDING_STATUS_TO_BMX_IDENTIFIED',
    CONFIRMATION_SERVICE_ERROR: 'CONFIRMATION_SERVICE_ERROR',
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    updateOnboardingStatus() {
        return {
            type: ACTIONS.VERIFY_PM_ELIGIBILITY,
        };
    },

    updateOnboardingStatusToBMXIdentified() {
        return {
            type: ACTIONS.UPDATE_ONBOARDING_STATUS_TO_BMX_IDENTIFIED,
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.CONFIRMATION_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};